import { render } from "./CheckmarkItem.vue?vue&type=template&id=a24eb70c"
import script from "./CheckmarkItem.vue?vue&type=script&lang=js"
export * from "./CheckmarkItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__